

<script>

/*eslint-disable*/
$(document).ready(function () {

  $("body").click(function () {
    $("#test").hide()
    if ($("#test").hide()) {
      $('.fa-xmark').hide()
      $('.burger-icon').show()
    }

  });

  $('.burger-icon').click(function (e) {
    e.stopPropagation();
    $('#test').fadeToggle()
    if ($('#test').show()) {
      $('.burger-icon').hide()
      $('.fa-xmark').show()
    }
  })

  $('.fa-xmark').click(function (e) {
    e.stopPropagation();
    $('#test').hide()
    if ($('#test').hide()) {
      $('.burger-icon').show()
      $('.fa-xmark').hide()
    }
  })

  $('.game_btn').click(function (e) {
    e.stopPropagation();
    $('.game').show()
  })

});



export default {
  methods: {
    increment() {
      $(document).ready(function () {

      });

    }
  },
}


</script>


<style scoped>
.game_btn {}

.header {
  display: flex;
  justify-content: space-between;
}

.nav {
  font-size: 1.4rem;
  justify-content: center;
  position: relative;
  top: 8px;
}

.nav a {
  margin: .5rem;
}

.nav a:hover {
  color: #FBB91C;
  transition: .3s all;
}


.nav a:before {
  content: url('../assets/star_black.png');
  margin-left: .5rem;
  position: relative;
  top: 4px;
}

.nav a:hover:before {

  content: url('../assets/star_yellow.png');
  transition: .5s all;
}

.share {
  width: 200px;
  display: flex;
  justify-content: end;
  position: relative;
  top: -8px;
}

.share img {
  width: 40px;
  padding: 10px 5px;
}

.logo {
  width: 200px;
  height: 55px;
  display: flex;
  justify-content: start;
}



@media screen and (max-width:1200px) {

  .burger {
    display: flex;
    width: 300px;
    height: 80%;
    top: 0;
    flex-direction: column;
    position: absolute;
    background: #EEEBE4;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    border-radius: 0px 0px 20px 0px;
  }

  .burger-inner,
  .burger {
    position: fixed;
    z-index: 9999999;
    margin: auto;
  }

  .burger a {
    margin: .5rem;

  }

  .burger a:before {
    content: url('../assets/star_black.png');
    position: relative;
    top: 0.3rem;

  }

  .burger a:hover {
    color: #FBB91C;
    transition: .1s all;
  }

  .burger a:hover::before {
    content: url('../assets/star_yellow.png');
    position: relative;
    top: 0.3rem;

  }



  .burger-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    margin: 5rem 1rem;
    font-size: 1.2rem;
  }


  .burger-inner img {
    width: 260px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .fa-xmark {
    position: absolute;
    margin-top: 15px;
    left: 1.8rem;
  }


  .share {
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    margin-right: 5px;
    position: relative;
    right: 0rem;
  }

  .share img {
    width: 30px;
    padding: 10px 5px;
  }

  .logo {
    width: 170px;
    height: 45px;
    margin-top: 8px;
  }

  .fa-bars {
    margin-top: 15px;
    margin-left: 10px;
    position: relative;
    top: -1px;
    left: 1rem;
  }


  .header {
    background: var(--main-bg-color);
    position: fixed;
    width: 100%;
    top: -1rem;
    margin: auto;
    display: flex;
    margin: 1rem auto;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    z-index: 999999;
  }
}



@media screen and (max-width:768px) {

  .burger {
    height: 100%;
    display: flex;
    width: 300px;
  }

  .burger-inner img {
    width: 250px;


  }


  .share {

    position: relative;
    right: 0rem;
  }

  .share img {
    width: 30px;
    padding: 10px 5px;
  }

  .logo {
    width: 170px;
    height: 45px;
    margin-top: 8px;
  }

  .fa-bars {
    margin-top: 15px;
    margin-left: 1px;
    position: relative;
    top: -1px;
    left: 1rem;
  }
}

@media screen and (max-width:500px) {


  .burger {
    display: flex;
    width: 250px;
  }

  .burger-inner img {
    width: 200px;


  }

  .logo {
    width: 150px;
    height: 40px;
    margin-top: 10px;
    position: relative;
    right: 1rem;
  }

  .share {
    margin-top: 10px;
    position: relative;
    right: 3rem;
  }


  .fa-bars {
    margin-top: 14px;
    margin-left: 8px;
    left: 1rem;
  }


}






.mb {
  display: none;
}

.pc {
  display: block;
}

@media screen and (max-width:1000px) {

  .mb {
    display: block;
  }

  .pc {
    display: none;
  }
}
</style>
